import { render } from "./HeaderProduct.vue?vue&type=template&id=47e09b3d&scoped=true"
import script from "./HeaderProduct.vue?vue&type=script&lang=js"
export * from "./HeaderProduct.vue?vue&type=script&lang=js"

import "./HeaderProduct.vue?vue&type=style&index=0&id=47e09b3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e09b3d"]])

export default __exports__